class Newsletter {

  constructor() {

    if (!this.setVars())
      return

    this.setEvents()

  }

  setVars() {

    this.section = document.querySelector('.newsletter')

    if (!this.section)
      return

    this.wrapper = this.section.querySelector('.newsletter__inner')
    this.form    = this.wrapper.querySelector('.newsletter__form')

    return true

  }

  setEvents() {

    this.form.addEventListener('submit', (e) => {

      e.preventDefault()
      this.sendForm()

    })

  }

  sendForm() {

    var email_val = $('#newsletter-form-email').val();
    var agree_val = $('input[name=agree]:checked', '#newsletter-form').val();
    if (agree_val == null || agree_val == false || agree_val != 'ON' || email_val == '') {
        if (email_val == '') { $('#newsletter-form-email').css('background-color', 'rgb(255, 220, 220)');}
        if (agree_val == null || agree_val == false || agree_val != 'ON') { $('.newsletter__item').css('background-color', 'rgb(255, 220, 220)');}
        alertPopup('Wypełnij obowiązkowe pola.');
    }
    else {
        var that = this;
        $.getJSON("/addSubscriber?email="+email_val+"&agree="+agree_val, function(data){
            if (data.status == 'success') {
                that.wrapper.addClass('newsletter__inner--response')
            }
            else if (data.status == 'error') {
                alertPopup(data.message);
            }
        });

    }

  }

}
